const FETCH_USER_CART_ITEMS = "user/cart_items/FETCH_USER_CART_ITEMS";
const FETCH_USER_CART_ITEMS_SUCCESS =
  "user/cart_items/FETCH_USER_CART_ITEMS_SUCCESS";
const FETCH_USER_CART_ITEMS_FAIL = "user/cart_items/FETCH_USER_CART_ITEMS_FAIL";
const UPDATE_USER_CART_ITEMS = "user/cart_items/UPDATE_USER_CART_ITEMS";
const UPDATE_USER_CART_ITEMS_SUCCESS =
  "user/cart_items/UPDATE_USER_CART_ITEMS_SUCCESS";
const UPDATE_USER_CART_ITEMS_FAIL =
  "user/cart_items/UPDATE_USER_CART_ITEMS_FAIL";
const SUBMIT_USER_CART_ITEMS = "user/cart_items/SUBMIT_USER_CART_ITEMS";
const SUBMIT_USER_CART_ITEMS_SUCCESS =
  "user/cart_items/SUBMIT_USER_CART_ITEMS_SUCCESS";
const SUBMIT_USER_CART_ITEMS_FAIL =
  "user/cart_items/SUBMIT_USER_CART_ITEMS_FAIL";
const ADD_USER_CART_ITEM = "user/cart_items/ADD_USER_CART_ITEM";
const ADD_USER_CART_ITEM_SUCCESS = "user/cart_items/ADD_USER_CART_ITEM_SUCCESS";
const ADD_USER_CART_ITEM_FAIL = "user/cart_items/ADD_USER_CART_ITEM_FAIL";
const REMOVE_USER_CART_ITEM = "user/cart_items/REMOVE_USER_CART_ITEM";
const REMOVE_USER_CART_ITEM_SUCCESS =
  "user/cart_items/REMOVE_USER_CART_ITEM_SUCCESS";
const REMOVE_USER_CART_ITEM_FAIL = "user/cart_items/REMOVE_USER_CART_ITEM_FAIL";
const initialState = {
  pending: true,
  loaded: false,
  oldCartItems: {},
  cart_items: {},
  errors: null,
  dirty: null,
  campaign_id: null,
  promo_offering_id: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_USER_CART_ITEMS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_USER_CART_ITEMS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        oldCartItems: { ...action.results },
        cart_items: { ...action.results },
        errors: null
      });
    case FETCH_USER_CART_ITEMS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case UPDATE_USER_CART_ITEMS:
      return Object.assign({}, state, {
        dirty: true,
        cart_items: action.cart_items
      });
    case UPDATE_USER_CART_ITEMS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        cart_items: { ...action.results },
        errors: null
      });
    case UPDATE_USER_CART_ITEMS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case SUBMIT_USER_CART_ITEMS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_USER_CART_ITEMS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        oldCartItems: { ...action.results },
        cart_items: { ...action.results },
        dirty: false,
        errors: null
      });
    case SUBMIT_USER_CART_ITEMS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case ADD_USER_CART_ITEM:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case ADD_USER_CART_ITEM_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        errors: null,
        campaign_id: action.results.campaign_id,
        promo_offering_id: action.results.promo_offering_id
      });
    case ADD_USER_CART_ITEM_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    case REMOVE_USER_CART_ITEM:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case REMOVE_USER_CART_ITEM_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        dirty: false,
        errors: null,
        campaign_id: action.results.campaign_id,
        promo_offering_id: action.results.promo_offering_id
      });
    case REMOVE_USER_CART_ITEM_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });
    default:
      return state;
  }
}

export function fetchUserCartItemsPending() {
  return {
    type: FETCH_USER_CART_ITEMS
  };
}

export function fetchUserCartItemsSuccess(results) {
  return {
    type: FETCH_USER_CART_ITEMS_SUCCESS,
    results
  };
}

export function fetchUserCartItemsFail(errors) {
  return {
    type: FETCH_USER_CART_ITEMS_FAIL,
    errors
  };
}

export function updateUserCartItems(cart_items) {
  return {
    type: UPDATE_USER_CART_ITEMS,
    cart_items
  };
}

export function updateUserCartItemsSuccess(results) {
  return {
    type: UPDATE_USER_CART_ITEMS_SUCCESS,
    results
  };
}

export function updateUserCartItemsFail(errors) {
  return {
    type: UPDATE_USER_CART_ITEMS_FAIL,
    errors
  };
}

export function submitUserCartItemsPending() {
  return {
    type: SUBMIT_USER_CART_ITEMS
  };
}

export function submitUserCartItemsSuccess(results) {
  return {
    type: SUBMIT_USER_CART_ITEMS_SUCCESS,
    results
  };
}

export function submitUserCartItemsFail(errors) {
  return {
    type: SUBMIT_USER_CART_ITEMS_FAIL,
    errors
  };
}

export function addUserCartItemPending() {
  return {
    type: ADD_USER_CART_ITEM
  };
}

export function addUserCartItemSuccess(results) {
  return {
    type: ADD_USER_CART_ITEM_SUCCESS,
    results
  };
}

export function addUserCartItemFail(errors) {
  return {
    type: ADD_USER_CART_ITEM_FAIL,
    errors
  };
}

export function removeUserCartItemPending() {
  return {
    type: REMOVE_USER_CART_ITEM
  };
}

export function removeUserCartItemSuccess(results) {
  return {
    type: REMOVE_USER_CART_ITEM_SUCCESS,
    results
  };
}

export function removeUserCartItemFail(errors) {
  return {
    type: REMOVE_USER_CART_ITEM_FAIL,
    errors
  };
}

export const getCartItems = state => state.cart_items;
export const getValidCartItems = state => state.oldCartItems;
export const getCartItemsError = state => state.errors;
export const getCartItemsPending = state => state.pending;
export const getCartItemsLoaded = state => state.loaded;
export const getCartItemsDirty = state => state.dirty;
export const getCartItemsCampaignId = state => state.campaign_id;
export const getCartItemsPromoOfferingId = state => state.promo_offering_id;
